import { render, staticRenderFns } from "./TabTrafficNotification.vue?vue&type=template&id=dc1d3728&scoped=true&"
import script from "./TabTrafficNotification.vue?vue&type=script&lang=js&"
export * from "./TabTrafficNotification.vue?vue&type=script&lang=js&"
import style0 from "./TabTrafficNotification.vue?vue&type=style&index=0&id=dc1d3728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1d3728",
  null
  
)

export default component.exports